/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Risk_Short_HighInputs */



/**
* | output |
* | --- |
* | "High" |
*
* @param {Audit_Logs_Risk_Short_HighInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_risk_short_high = /** @type {((inputs?: Audit_Logs_Risk_Short_HighInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Risk_Short_HighInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hoch")
	return /** @type {LocalizedString} */ ("High")
});